import permissions from '../../permissions'

const LAST_UPDATE_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.VISUALIZE,
    tag: permissions.LAST_UPDATES.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.LAST_UPDATES.CREATE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.DESTROY,
    tag: permissions.LAST_UPDATES.DESTROY,
  },
]

export default LAST_UPDATE_LIST
